import Basil from "basil.js"

const store = new Basil({
  namespace: "",
  storages: ["local", "cookie", "session", "memory"]
})

const storage = {enabled: true}

function wrap(fn, errorHandler) {
  return function() {
    try {
      return fn.apply(this, arguments)
    } catch (e) {
      return errorHandler(e)
    }
  }
}

function handleError() {
  if (!storage.enabled) return

  storage.enabled = false
}

storage.set = wrap(store.set, handleError).bind(store)
storage.get = wrap(store.get, handleError).bind(store)
storage.remove = wrap(store.remove, handleError).bind(store)
storage.clear = wrap(store.reset, handleError).bind(store)

export default storage
